<div>
    <h1 id="successful-title" class="text">{{this.documentInfo.firstname}}, {{copyService.copies.detail_bonding_aprove}}
    </h1>
    <br>
    <div class="title-bold" [innerHTML]="copyService.copies.label_checkbox_cards"></div>
    <div class="quota-text">{{copyService.copies.detail_bonding_aprove_quota}}</div>
    <h3 class="money">$6.000.000</h3>
    <div class="subTitle">{{copyService.copies.detail_bonding_aprove_subtitle}}</div>
    <div class="characters">
        <div class="space">
            <voxel-icon class="icon">
                chat_enviado
            </voxel-icon>
            <h3 class="character">{{copyService.copies.detail_bonding_aprove_number}}</h3>
        </div>
        <br>
        <hr>
        <div class="space">
            <voxel-icon class="icon">
                chat_enviado
            </voxel-icon>
            <h3 class="character">{{copyService.copies.detail_bonding_aprove_date_finish}}</h3>
        </div>
        <br>
        <hr>

        <div class="space">
            <voxel-icon class="icon">
                chat_enviado
            </voxel-icon>
            <h3 class="character">{{copyService.copies.detail_bonding_send_phone}}</h3>
        </div>
        <br>
        <hr >
    </div>
    <div class="quota-text-franchise">{{copyService.copies.detail_bonding_franchise}}</div>
    <!-- tarjeta -->
    <div class="base-card">
        <div class="rectangle-copy">
            <div class="rectangle">
                <div class="virtual">{{copyService.copies.detail_bonding_example_card}}</div>
            </div>
            <div class="number-card">4904 5684 3891 7861</div>
            <div class="name-in-card">ANA MERIZALDE</div>

            <pre class="data-in-card">válido hasta                        $1.500.000</pre>
            <pre class="info-in-card">06/22                              cupo disponible </pre>
        </div>
        
        
    </div>

    <div *ngFor="let card of cards" class="wrapper">
        <div class="border">
            <voxel-icon class="iconCard">
                cartao_outline
            </voxel-icon>
            <div class="credit-title">{{card.title_card}}</div>
            <h3 class="text-card">{{card.text_card}}</h3>
            <p class="money-card">${{card.money_card}}</p>
        </div>
        <br>
    </div>
    <h3 class="text-info">{{copyService.copies.detail_bonding_text_info}}</h3>
    <br>

    <h3 class="more-benefits">{{copyService.copies.detail_bonding_more_benefits}}<a class="link-itau" href="www.itau.co">www.itau.co</a></h3>
    <br>
    <h3 class="text-info2">{{copyService.copies.detail_bonding_text_info_virtual_card}}</h3>
    <hr class="divide-hr">
    <div class="title-bold">{{copyService.copies.detail_bonding_credits}}</div>
    <div class="data-info">
        <div class="subTitle-info">{{copyService.copies.detail_bonding_order}}</div>
        <h3 class="tel">9087 - 4578 - 5</h3>
    </div>
    <div class="data-info">
        <div class="subTitle-info">{{copyService.copies.detail_bonding_rotative}}</div>
        <h3 class="tel">9012 - 3456 - 7</h3>
    </div>
    <hr class="divide-hr">
    <div class="title-bold">{{copyService.copies.detail_bonding_savings_account}}</div>
    <div class="data-info">
        <div class="subTitle-info">{{copyService.copies.detail_bonding_account_number}}</div>
        <h3 class="tel">5437 - 9876 - 3</h3>
    </div>
    <div class="data-info">
        <div class="subTitle-info">{{copyService.copies.detail_bonding_date_aperture}}</div>
        <h3 class="info">30 de junio 2020 a las 10:00 a.m.</h3>
    </div>
    <div class="data-info">
        <div class="subTitle-info">{{copyService.copies.detail_bonding_detail_bonding_solicitation_IP}}</div>
        <h3 class="info">190.66.2.204</h3>
    </div>
</div>
<div class="footer">
    <div class="additionalInfoTC">
        <span id="iconCheck" class="iconPhone icon-itaufonts_telefone additionalInfoTCIconPhone">
        </span>
        <p id="additionalInfoTCtext" class="additionalInfoTCtext">
            {{ copyService.copies.successful_credit_card_creation_info_itau_phone_part_1 }}
            <strong>{{ copyService.getParametrizedCopy('successful_credit_card_creation_info_itau_phone', [maskedPhone])
                }}</strong>
            {{ copyService.copies.successful_credit_card_creation_info_itau_phone_part_2 }}
        </p>
    </div>
    <div class="container">
        <app-controls id="detailAccountCreationBtns"
            [nextLabel]="copyService.copies.successful_credit_card_creation_control_button" [nextDisabled]="false"></app-controls>
    </div>
</div>